import { IUntypedCommand, Topics } from '@zaplify/common';
export class DeleteProspectsByIdsCommand extends IUntypedCommand {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly prospectIds: string[]) {
        super();
    }
}
